import * as React from 'react'
import { Container } from './Container'
import geometricM from './images/geometric-m-horizontal.png'
import marketxM from './images/marketx-m.png'
import styles from './styles.module.scss'
import Image from 'next/image'
import clsx from 'clsx'
import { IEvent, companiesData, eventsData } from './data/eventsData'
import { Dialog, Transition } from '@headlessui/react'
import { PlayIcon } from './PlayIcon'

function EventVideo({ event }: { event: IEvent }) {
  const [isOpen, setIsOpen] = React.useState(false)
  const videoId = event.youtubeVideoId

  function closeModal() {
    setIsOpen(false)
  }

  function openModal() {
    setIsOpen(true)
  }

  return (
    <>
      <button
        className="relative w-full h-auto aspect-video mb-5 md:mb-7 group overflow-hidden rounded-5xl"
        onClick={openModal}>
        <Image
          className="object-cover object-top group-hover:scale-105 transition-transform"
          src={event.image}
          alt={event.title}
          fill
        />
        <span className="absolute inset-0 flex items-center justify-center">
          <PlayIcon />
        </span>
      </button>
      <Transition appear show={isOpen} as={React.Fragment}>
        <Dialog as="div" className="relative z-[1000]" onClose={closeModal}>
          <Transition.Child
            as={React.Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0">
            <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={React.Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95">
                <Dialog.Panel className="w-full max-w-6xl transform overflow-hidden bg-black align-middle shadow-xl transition-all">
                  <iframe
                    className="aspect-video h-full w-full"
                    src={`https://www.youtube.com/embed/${videoId}?&autoplay=1`}
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                  />
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export function PreviousEvents() {
  return (
    <div className={clsx(styles.bgSummit, 'relative')}>
      <Image
        src={geometricM}
        alt=""
        unoptimized
        className="absolute right-0 h-28 w-auto top-0 hidden md:block"
      />
      <Image
        src={marketxM}
        alt=""
        unoptimized
        className="absolute right-0 w-[500px] bottom-0 left-0"
      />

      <Container className="relative py-14 lg:py-28">
        <h2
          className={clsx(
            styles.sectionTitleGradient,
            'font-body md:text-6xl lg:text-7xl sm:text-5xl text-4xl font-bold text-center mb-14 md:mb-20 md:max-w-2xl md:mx-auto',
          )}>
          Relive our previous events
        </h2>

        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-3 xl:gap-20 text-white mb-14 md:mb-24">
          {eventsData.map((event, index) => (
            <div key={index}>
              <EventVideo event={event} />
              <h3 className="font-bold text-2xl">{event.title}</h3>
              <p className="mt-1">{event.description}</p>
            </div>
          ))}
        </div>
        <h3
          className={clsx(
            styles.sectionTitleGradient,
            'font-body text-2xl font-bold text-center',
          )}>
          Attended by industry leaders.
        </h3>
        <div className="grid grid-cols-3 gap-8 md:gap-12 max-w-3xl mx-auto mt-14">
          {companiesData.map((company, index) => (
            <div key={index} className="relative w-full h-8 aspect-video">
              <Image
                className="object-contain object-center fill-gray-500"
                src={company.image}
                alt={company.name}
                fill
              />
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}
